import { metricsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';
import { keys } from 'lodash';
import JSON5 from 'json5';

const metrics = cachedRequestByIdReducer(metricsActionTypes, 'byJobId');
export default metrics;

const getMetricsState = state => state.metrics;
export const metricsByJobIds = state => getMetricsState(state).byJobId;
export const getMetricsByJobId = (state, jobId) => metricsByJobIds(state)[jobId];

export const getDisplayMetrics = (
  metrics, metricsDisplayList, perfMetricsDisplayList, perfMetricsKeyPrefixList) => {
  const metricNames = keys(metrics);
  const payload = {};
  metricNames.forEach(metricName => {
    if (metricsDisplayList.includes(metricName))
    {
      payload[metricName] = metrics[metricName];
    }
    if (perfMetricsDisplayList.includes(metricName))
    {
      const perfMetrics = JSON5.parse(
        metrics[metricName].slice(1, metrics[metricName].length - 1));
      const perfMetricNames = keys(perfMetrics);
      perfMetricNames.forEach(perfMetricName => {
        payload[convertArtifactPerformanceDiffMetric(
          perfMetricName,
          perfMetricsKeyPrefixList)] = perfMetrics[perfMetricName]['delta'];
      });
    }
  });
  return payload;
};

export const convertArtifactPerformanceDiffMetric = (metricName, prefixList) => {
  prefixList.forEach(prefix => {
    metricName = metricName.replace(prefix, '');
  });
  return 'Delta:' + metricName;
};

export const getExportMetrics = (metrics, scenarioName) => {
  const exportType = scenarioName.split('-', 1);
  const metricNames = keys(metrics);
  const payload = {};
  for (let i = 0; i < metricNames.length; i++) {
    if (metricNames[i].includes('-'))
    {
      if (exportType[0].toLowerCase() === metricNames[i].split('-', 1)[0].toLowerCase())
      {
        payload[metricNames[i]] = metrics[metricNames[i]];
      }
    }
    else
    {
      payload[metricNames[i]] = metrics[metricNames[i]];
    }
  }
  return payload;
};


// WEBPACK FOOTER //
// src/reducers/metrics.js